angular.module('festzelt-os.modules.guestlists', [
    'festzelt-os.components'
]);

require('./components/al-guestlist-dashboard/component');
require('./components/al-guestlist-editor/component');
require('./components/al-guestlist-protected-files/component');
require('./components/al-guestlist-templates/component');
require('./components/al-landingpage-editor/component');
require('./components/al-guestlists-grid-view/component');

require('./store/templates');



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/module.js